interface ISessionsAmountCartItem {
  quantidadeSessoes?: number;
  pacotes?: ISessionsAmountCartItem[];
}

const getSessionsAmounts = (item: ISessionsAmountCartItem): number[] => {
  if (item.pacotes && item.pacotes.length) {
    return item.pacotes.reduce<number[]>(
      (amounts, pack) => amounts.concat(getSessionsAmounts(pack)),
      [],
    );
  }

  return item.quantidadeSessoes ? [item.quantidadeSessoes] : [];
};

export const hasDifferentSessionsAmount = (
  items: ISessionsAmountCartItem[],
  newItem: ISessionsAmountCartItem,
): boolean => {
  const sessionsAmounts = [...items, newItem].reduce<number[]>(
    (amounts, item) => amounts.concat(getSessionsAmounts(item)),
    [],
  );

  return new Set(sessionsAmounts).size > 1;
};
